export const URGENCY_DISCOUNT_TYPES = [
  'dynamic_pricing',
  'dynamic_pricing_single_on_round_trip_discount',
  'early_trip_discount',
];

export const RESULT_DISCOUNT_UI_TYPES = [
  ...URGENCY_DISCOUNT_TYPES,
  'single_trip_discount',
  'departure_on_round_trip_discount',
  'single_on_round_trip_discount',
];

export const MAX_URGENCY_DISCOUNT_AVAILABILITY = 10;

/**
 * Checks whether a pricing discount type should use the urgency discount UI.
 *
 * @param {string} discountType - Pricing discount type.
 * @returns {boolean} Whether the discount type is eligible for the urgency UI.
 */
export const isUrgencyDiscountType = (discountType) =>
  URGENCY_DISCOUNT_TYPES.includes(discountType);

/**
 * Checks whether a pricing discount type should use the new results discount UI.
 *
 * @param {string} discountType - Pricing discount type.
 * @returns {boolean} Whether the discount type is eligible for the results discount UI.
 */
export const isResultDiscountUIType = (discountType) =>
  RESULT_DISCOUNT_UI_TYPES.includes(discountType);

/**
 * Checks whether provider discount data includes a usable amount for urgency UI.
 *
 * @param {object} providerDiscount - Provider discount information.
 * @returns {boolean} Whether a provider discount amount exists.
 */
export const hasUrgencyDiscountAmount = (providerDiscount) => Boolean(providerDiscount?.amount);

/**
 * Checks whether the discount availability is low enough to show urgency copy.
 *
 * @param {number} availability - Discount availability.
 * @returns {boolean} Whether the discount availability should be shown.
 */
export const shouldShowUrgencyDiscountAvailability = (availability) => {
  const parsedAvailability = Number(availability);

  return (
    Number.isFinite(parsedAvailability) &&
    parsedAvailability > 0 &&
    parsedAvailability <= MAX_URGENCY_DISCOUNT_AVAILABILITY
  );
};
